import React, { FunctionComponent, useState } from 'react'
import { getImageAlt, getImageTitle } from 'Root/Shared/utils/imageTools'

import PuxLightbox from '../../PuxLightbox/PuxLightbox'

export interface PuxPictureType extends MediaSelectorImageType {
  customAlt?: string
}

export interface MediaSelectorImageType {
  resizePaths: [string]
  resizePathsTablet: [string]
  resizePathsMobile: [string]
  resizePathsFallback: [string]
  texts: [string]
  width?: string | number
  height?: string | number
  lightbox?: boolean
  disableLazyload?: boolean
  type: [string]
}

interface LightboxSettingsType {
  onClick?: () => void
  className?: string
}

const DEFAULT_IMG_WIDTH = 1200
const DEFAULT_IMG_HEIGHT = 1200

const PuxPicture: FunctionComponent<PuxPictureType> = (props) => {
  const [toggler, setToggler] = useState(false)
  const lightboxSettings: LightboxSettingsType = {}

  if (props.lightbox) {
    lightboxSettings.onClick = () => setToggler(!toggler)
    lightboxSettings.className = `has-lightbox`
  }

  const isSvg = props.type?.find(x => x)?.toLowerCase() === 'image/svg+xml';

  if (isSvg && props.resizePathsFallback?.length && props.resizePathsFallback?.find(x => x)) {
    return (
      <>
        <img
          {...lightboxSettings}
          loading={props.disableLazyload ? `eager` : `lazy`}
          {...{ fetchpriority: props.disableLazyload ? `high` : `low` }}
          src={props.resizePathsFallback?.find(x => x)}
          title={props.texts ? getImageTitle(props.texts?.find(x => x) ?? ``) : ``}
          alt={
            props.texts ? getImageAlt(props.texts?.find(x => x) ?? ``) : props.customAlt ?? ``
          }
          width={props.width ?? DEFAULT_IMG_WIDTH}
          height={props.height ?? DEFAULT_IMG_HEIGHT}
        />
        {props.lightbox && (
          <PuxLightbox
            toggler={toggler}
            sources={[props.resizePathsFallback?.find(x => x) ?? '']}
            type='image'
          />
        )}
      </>
    );
  }

  if (props?.resizePaths?.length && (props.resizePaths?.find(x => x)?.length ?? 0 > 0)) {
    return (
      <>
        <picture {...lightboxSettings}>
          <source media='(min-width:1200px)' srcSet={props.resizePaths?.find(x => x)} />
          {props.resizePathsTablet?.length && (
            <source
              media='(min-width:768px)'
              srcSet={props.resizePathsTablet?.find(x => x)}
            />
          )}
          {props.resizePathsMobile?.length && (
            <source
              media='(min-width:320px)'
              srcSet={props.resizePathsMobile?.find(x => x)}
            />
          )}
          <img
            loading={props.disableLazyload ? `eager` : `lazy`}
            {...{ fetchpriority: props.disableLazyload ? `high` : `low` }}
            src={props.resizePathsFallback?.find(x => x)}
            title={props.texts ? getImageTitle(props.texts?.find(x => x) ?? ``) : ``}
            alt={
              props.texts ? getImageAlt(props.texts?.find(x => x) ?? ``) : props.customAlt ?? ``
            }
            width={props.width ?? DEFAULT_IMG_WIDTH}
            height={props.height ?? DEFAULT_IMG_HEIGHT}
          />
        </picture>
        {props.lightbox && (
          <PuxLightbox
            toggler={toggler}
            sources={[props.resizePathsFallback?.find(x => x) ?? '']}
            type='image'
          />
        )}
      </>
    )
  } else {
    return null
  }
}

export default PuxPicture
